module.exports = __webpack_public_path__ + "img/wenti_banner_es.6047d964.jpg";